import React from 'react'
import { Icon, TooltipPopOver } from '@ztechapps/webui.util'
import { formatMoney } from '@ztechapps/common.utils'
import type { Product } from '@ztechapps/common.contract'

export const BomComponentCostOverlay = ({ product }: { product: Product }) => {
  const { miscellaneousCost, totalOperationsCost, totalManufactureCost, totalSubComponentsCost } = product ?? {}

  return (
    <TooltipPopOver
      tooltipBody={
        <div>
          <table className="w-100 table table-sm " style={{ minWidth: '200px' }}>
            <tbody>
              <tr>
                <td className=" ">Miscellaneous cost</td>
                <td className={'  text-end'}>{formatMoney(miscellaneousCost)}</td>
              </tr>
              <tr>
                <td className=" ">Operation cost</td>
                <td className={'  text-end'}>{formatMoney(totalOperationsCost)}</td>
              </tr>
              <tr>
                <td className=" ">Sub-assemblies</td>
                <td className={'  text-end'}>{formatMoney(totalSubComponentsCost)}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr className="table-secondary">
                <th>Total</th>
                <th className="text-end">{formatMoney(totalManufactureCost)}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      }
    >
      <span className={'ps-2'}>
        <Icon name={'circle-question'} />
      </span>
    </TooltipPopOver>
  )
}
